import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
/*
import { GatsbyImage, getImage } from "gatsby-plugin-image"
*/

export const BlogPostTemplate = ({
  content,
  title,
  date,
  categories
}) => {
  return (
    <React.Fragment>
      <section className="layout-banner">
        <h1 className="post-title">{title}</h1>
        <div className="content">
          <h4>{date}</h4>
        </div>
        
      </section>  
        
      <section className="layout-column-width">
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      </section>

      <section className="layout-centered offset-top">
        <div className="content">
        {
        categories.nodes && categories.nodes.length ? (
          <div className="back-links">
            <ul className="taglist">
              {categories.nodes.map(category => (
                <li key={`${category.name}cat`}>
                  {category.name === 'Tips and Recipes' ? 
                  <p className='cta button'><Link to="/tips-recipes">Back to Tips and Recipes</Link></p> : ''
                  }
                  {category.name === 'News' ? 
                  <p className='cta button'><Link to="/news">Back to News</Link></p> : ''
                  }
                </li>
              ))}
            </ul>
          </div>
        ) : null 
        }
        </div>
      </section>
    </React.Fragment>
    
  )
}

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string,
}


/*
        {Array.isArray(categories) ? <p className='cta button'><Link to="/news">Back to News</Link></p> : <p>Don't go back</p> }
        */